export const firebaseConfig = {
  apiKey: "AIzaSyAgHs_oNlUmbLQfUoqNYZDTRFBv-LHWUcU",
  authDomain: "bridge-brawl-1b73c.firebaseapp.com",
  projectId: "bridge-brawl-1b73c",
  storageBucket: "bridge-brawl-1b73c.firebasestorage.app",
  messagingSenderId: "33127185538",
  appId: "1:33127185538:web:581f0e713ebb6f9c40089b",
  measurementId: "G-JL2ND0PJ40"
};